import axios from "axios";
import {
    ADD_APPLICANT_COMMENT,
    APPLICANT_FILES,
    APPLICANT_SEARCH,
    GET_APPLICANT_DATA_BY_EMAIL,
    GET_APPLICANT_DATA_BY_ID,
    SHORT_LIST_CANDIDATE_POST,
    SCREENING_SCHEDULE,
    CREDITS,
    AVAILABLE_CREDITS,
    CREDIT_TRANSACTIONS,
    PUBLIC_APPLICATION_LINK,
    VETTING,
    SEND_TO_DIRECTOR,
    SCREENING_CHECKLIST,
    APPLICANT_FILES_TO_INPUT_CHECKLIST,
    CANDIDATE_CV_EXTRACTION,
    CANDIDATE_DOCUMENT_EXTRACTION
} from "@/app/Config/ScreeningAppUrl";
import {axiosDelete, axiosPost, axiosPut} from "@/app/Helpers/AxiosHelper";

export const Search = {
    getApplicantSearch: (candidateId) => axios.get(`${APPLICANT_SEARCH + candidateId}`),
    saveScreeningSearch: (candidateId, body) => axios.post(`${APPLICANT_SEARCH + candidateId}`, body)
}

export const File = {
    uploadDocument: (formData) => axiosPost(`${APPLICANT_FILES}`, formData),
    updateDocument: (documentId, formData) => axiosPost(`${APPLICANT_FILES}/${documentId}`, formData),
    attachDocumentToChecklist: (formData) => axiosPost(`${APPLICANT_FILES_TO_INPUT_CHECKLIST}`, formData),
    deleteDocument: (applicantFileId) => axios.delete(`${APPLICANT_FILES}/${applicantFileId}`)
}

export const Candidate = {
    extractCv: (formData) => axiosPost(CANDIDATE_CV_EXTRACTION, formData),
    extractDocuments: (formData) => axiosPost(CANDIDATE_DOCUMENT_EXTRACTION, formData),
    shortListCandidate: (applicantId) => axiosPost(`${SHORT_LIST_CANDIDATE_POST}/${applicantId}`, {}),
    getCandidateByEmail: (email) => axios.get(`${GET_APPLICANT_DATA_BY_EMAIL + email}`),
    getCandidateById: (candidateId, applicantArchiveId = null) => axios.get(`${GET_APPLICANT_DATA_BY_ID + candidateId}&applicantArchiveId=${applicantArchiveId}`),
    getScreeningSchedule: () => axios.get(`${SCREENING_SCHEDULE}`),
    postScreeningSchedule: (body) => axiosPost(`${SCREENING_SCHEDULE}`, body),
    postVetting: (id, body) => axiosPost(`${VETTING}/${id}`, body),
    updateVetting: (id, body) => axiosPut(`${VETTING}/${id}`, body),
    postScreeningChecklist: (applicantId, body) => axiosPost(`${SCREENING_CHECKLIST}/${applicantId}`, body),
}

export const Comment = {
    saveComment: (applicantId, commentObj) => axiosPost(`${ADD_APPLICANT_COMMENT}/${applicantId}`, commentObj),
    editComment: (applicantId, commentId, commentObj) => axiosPost(`${ADD_APPLICANT_COMMENT}/${applicantId}/${commentId}`, commentObj),
    deleteComment: (commentId) => axiosDelete(`${ADD_APPLICANT_COMMENT}/${commentId}`),
}

export const Credits = {
    getCredits: () => axios.get(`${CREDITS}`),
    getAvailableCredits: () => axios.get(`${AVAILABLE_CREDITS}`),
    getCreditTransactions: () => axios.get(`${CREDIT_TRANSACTIONS}`),
    postCredit: (request) => axiosPost(`${CREDITS}`, request)
}

export const NewApplication = {
    getPublicAppLink: (request) => axiosPost(`${PUBLIC_APPLICATION_LINK}`, request),

}
